import { AppBar, Toolbar } from '@mui/material';
import { COLORS } from 'theme/colors';
import { User } from 'types/user';
import { NavTabsClient } from './NavTabsClient';
import { NavTabsDefault } from './NavTabsDefault';

interface Props {
  user: User | null;
}

export const Navbar = ({ user }: Props) => {
  if (!user) return null;
  return (
    <>
      <AppBar position='fixed' sx={{ bgcolor: COLORS.DARK_BLUE }}>
        <Toolbar>
          {user.clientPanelUser ? (
            <NavTabsClient user={user} />
          ) : (
            <NavTabsDefault user={user} />
          )}
        </Toolbar>
      </AppBar>
      {/* NOTE: second Toolbar prevents hidding content behind the main one - mui doc solution */}
      <Toolbar />
    </>
  );
};
